<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal hide-footer id="rrc-view-modal" size="lg" title="RRC View">

      <div class="modal-content bg-white rounded box-shadow">
        <table class="table table-centered table-striped">
          <tr>
            <th>Deed Number</th>
            <td>{{ rrc.deed_number }}</td>
          </tr>
          <tr>
            <th>Deed Date</th>
            <td>{{ rrc.deed_date }}</td>
          </tr>
          <tr>
            <th>Mouza</th>
            <td>{{ rrc.mouza }}</td>
          </tr>
          <tr>
            <th>Upazila</th>
            <td>{{ rrc.upazila }}</td>
          </tr>
          <tr>
            <th>Sub Req Office</th>
            <td>{{ rrc.sub_reg_office }}</td>
          </tr>
          <tr>
            <th>Reg Fee</th>
            <td>{{ rrc.reg_fee }}</td>
          </tr>
          <tr>
            <th>Land Type</th>
            <td>{{ rrc.land_type ? rrc.land_type.land_type_desc : ''}}</td>
          </tr>
          <tr>
            <th>Land Quantity</th>
            <td>{{ rrc.land_quantity }}</td>
          </tr>
          <tr>
            <th>Land Value</th>
            <td>{{ rrc.land_value }}</td>
          </tr>
          <tr>
            <th>Replacement Value</th>
            <td>{{ rrc.replacement_value }}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: "viewRrcModal",
  props: ['rrc'],
  components: {},
  data() {
    return {

    };
  },

  mounted() {

  },
  methods: {

  },
};
</script>
